// FinishStepContent - simplified for driver.js which provides its own Done button
const FinishStepContent = () => {
  return <p>We hope this guide was helpful. You can always access it again from the How-To Guide section.</p>;
};

// Factory function to create content that receives step controls from useDriverTour
export const createFinishStepContent = () => () => <FinishStepContent />;

export default FinishStepContent;
